import React, { useEffect, useState } from "react";
import type { IStep } from ".";
import { Input } from "../../components/Steps";
import type { IAnswers } from "../../steps";
import { useSelector } from "react-redux";
import { isDaily } from "../../reducers/steps/selectors";
import { addRange, mapLitresToRange } from "../../components/Steps/Custom/CustomStep4";

export interface AnswerProps {
  step: IStep;
  onChange: (answer: IAnswers, value?: string) => void;
  value?: string;
}

function Answer({ step, onChange, value }: AnswerProps) {
  const daily = useSelector(isDaily);
  const [added, setAdded] = useState<boolean>(daily && !!value);
  const normalizeValue = (rawValue?: string, shouldSubtract?: boolean) => {
    if (!rawValue) {
      return "";
    }

    if (!shouldSubtract) {
      return rawValue;
    }

    const parsed = Number(rawValue);
    if (Number.isNaN(parsed)) {
      return rawValue;
    }

    return (parsed - 50).toString();
  };
  const [internalValue, setInternalValue] = useState<string>(
    normalizeValue(value, daily && !!value)
  );

  useEffect(() => {
    setInternalValue(normalizeValue(value, added));
  }, [value, added]);

  const change = (answer: IAnswers) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const currentValue = e.currentTarget.value;
    setInternalValue(currentValue);
    onChange(answer, currentValue);
    setAdded(false);
  };

  const onblur =
    (answer: IAnswers) => (e: React.FocusEvent<HTMLInputElement>) => {
      if (step.step === "11" || step.step === "12") {
        const customFilters: Record<string, string | undefined> = {};
        let value1 = Number(e.currentTarget.value);
        if (daily) {
          value1 = value1 + 50;
          setAdded(true);
        }
        const mappedRange = mapLitresToRange(Number(value1));
        customFilters["Średnie zapotrzebowanie dla:"] = mappedRange;
        customFilters["(Max) Średnie zapotrzebowanie dla:"] = addRange(mappedRange);
        onChange({ ...answer, customFilters } as IAnswers, String(value1));
      }
    };

  return (
    <>
      {step.answers.map((a, i) => {
        const debugFeatures = step.ansewers?.[i]?.features;
        return (
          <React.Fragment key={a.name}>
            <Input
              type={"number"}
              value={internalValue}
              onBlur={onblur(a)}
              onChange={change(a)}
              placeholder={a.content}
            />
            {process.env.REACT_APP_DEBUG && debugFeatures && (
              <div style={{ marginTop: "-20px", marginBottom: "20px" }}>
                {debugFeatures.map((f: any) => (
                  <p key={f.nameVerbose}>
                    {f.nameVerbose} {f.valueVerbose}
                  </p>
                ))}
              </div>
            )}
          </React.Fragment>
        );
      })}
    </>
  );
}

export default Answer;
